export const REQUIRED_CONFIG_PARAMS = ['api']
// export const REQUIRED_WEBSOCKET_PARAMS = ['url']

export const DEFAULT_AXIOS_OPTIONS = {
  timeout: 40 * 1000, //40seconds
}
